import { InjectionToken } from '@angular/core';

export interface OpenWeatherConfig {
  appId: string;
  currentUrl: string;
  forecastUrl: string;
  mapTilesUrl: string;
}

export const OPEN_WEATHER_CONFIG = new InjectionToken<OpenWeatherConfig>('weather.OpenWeatherConfig');
